export const initialModalState = (): ModalState => ({
  single: {
    printBannerForm: false,
    printBannerFile: false,
    printBannerFiles: false,
    recoverPassword: false,
    confirmBannerFormsDeletion: false,
    confirmSession: false,
    createInvoice: false,
    createTax: false,
    createCompany: false,
    updateInvoice: false,
    updateTax: false,
    updateCompany: false,
    filterCompany: false,
    filterInvoice: false,
    filterTax: false,
    filterLogistic: false,
    filterLogisticOrigin: false,
    createDeposit: false,
    updateDeposit: false,
    filterDeposit: false,
    deleteInvoices: false,
    deleteTaxes: false,
    deleteCompanies: false,
    deleteDeposits: false,
    printInvoices: false,
    updateManyDeposits: false,
    createValidity: false,
    updateValidity: false,
    filterValidity: false,
    deleteValidity: false,
    createStatus: false,
    updateStatus: false,
    filterStatus: false,
    deleteStatus: false,
    createLogistic: false,
    createLogisticOrigin: false,
    updateLogistic: false,
    updateLogisticOrigin: false,
    deleteLogistics: false,
    deleteLogisticOrigins: false,
  },
});
